import * as z from "zod";
import { cursorPagination, decimal } from "../index";
import { soLineStatuses } from "./enums";

// Lines of a sales order (50-api/sales.md §2.2).

/** By line number. */
export const listSalesOrderLinesInput = z.object({
  salesOrderId: z.uuid(),
  status: z.enum(soLineStatuses).optional(),
  ...cursorPagination({ defaultLimit: 200, maxLimit: 500 }),
});
export type ListSalesOrderLinesInput = z.input<typeof listSalesOrderLinesInput>;
export const salesOrderLinesQuery = listSalesOrderLinesInput.omit({ salesOrderId: true });

/** A line of a sales order with what its SKU is. `lineNo` is never reused: every system names the line by it. */
export const salesOrderLineDto = z
  .object({
    id: z.uuid(),
    lineNo: z.number().int(),
    skuId: z.uuid(),
    skuCode: z.string().nullable(),
    ean: z.string().nullable(),
    styleCode: z.string().nullable(),
    styleName: z.string().nullable(),
    colour: z.string().nullable(),
    size: z.string().nullable(),
    qtyOrdered: z.number().int(),
    qtyAllocated: z.number().int(),
    qtyFulfilled: z.number().int(),
    /** Units a PO lowered by its supplier no longer brings, which the line could not lose (ADR-187). */
    qtyUncovered: z.number().int(),
    /** Wholesale price of one unit before discounts, in the currency of the order. */
    unitPrice: decimal.optional(),
    discountPct: decimal.nullable().optional(),
    status: z.enum(soLineStatuses),
    closedReason: z.string().nullable(),
  })
  .meta({ id: "SalesOrderLine" });
